import React from 'react'
import styled from 'styled-components'
import { ArrowRight } from '@styled-icons/bootstrap'
import { Dollar } from '@styled-icons/boxicons-regular'
import { Flash } from '@styled-icons/entypo'
import { Sun } from '@styled-icons/evaicons-solid'
import { Moon } from '@styled-icons/heroicons-solid'
import { Calendar } from '@styled-icons/feather'
import { Location } from '@styled-icons/evil'
import { Bus2 } from '@styled-icons/remix-fill'
import ButtonTC from '../../../components/button-tc/button-tc'
import { device } from '../../../config/theme/breakpoints'
import TicketItem from '../../change-destiny/components/ticket-item/ticket-item'
import { listTicketItem } from '../../change-destiny/data'
import FilterItem from '../../change-destiny/components/filter-item/filter-item'
import CalendarTC from '../../../components/calendar-tc/calendar-tc'
import SelectTC from '../../../components/select-tc/select-tc'

const ContainerDestinations = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 20px;
`

const ContainerSearch = styled.div<{ hidden: boolean }>`
  width: 100%;
  display: ${p => p.hidden ? 'none' : 'block'};

  @media ${device.tablet}{
    width: 25%;
    display: ${p => p.hidden ? 'block' : 'none'};
  }
`
const ContainerData = styled.div`
  background: ${p => p.theme.palette.primary.main};
  border-radius: 15px;
  min-height: 100px;
  padding: 10px 12px;

  > div:nth-child(1){
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    
    > h3 {
      color: white;
      font-weight: 400;
      margin: 0;
    }
  }

  > div:nth-child(1) svg{
    max-width: 30px;
    color: ${p => p.theme.palette.secondary.main};
    
  }
`

const ContainerForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const ContainerTicket = styled.div`
  width: 100%;

  > div h3 {
    color:  ${p => p.theme.palette.primary.main};
    margin-bottom: 10px;
  }

  > div h3 svg {
    max-width: 20px;
    color:  ${p => p.theme.palette.secondary.main};
    margin: 0 10px;
  }

  @media ${device.tablet}{
    width: 70%;
  }
`
const ContainerFilter = styled.div`
  color: ${p => p.theme.palette.text.gray};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;

  @media ${device.tablet}{
    flex-direction: row;
  }
`
const ContainerFilters = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: ${p => p.theme.palette.text.gray};
  gap: 10px;
  flex-wrap: wrap;

  @media ${device.tablet}{
    justify-content: flex-end;
  }
`

const DestinyBar = styled.div`
  background: ${p => p.theme.palette.text.grayLight};
  border-radius: 4px 4px 15px 15px;
  position: relative;
  width: 100%;
  height: 8px;

  :after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 20%;
    height: 8px;
    border-radius: 4px 4px 15px 15px;
    background: ${p => p.theme.palette.primary.main};
  }
`
const CustomRadio = styled.div<{ active: boolean }>`
  width: 20px;
  height: 20px;
  background: transparent;
  border-radius: 50%;
  border: 2px solid ${p => p.active ? p.theme.palette.secondary.main : 'white'};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  
  > div {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${p => p.active ? p.theme.palette.secondary.main : 'white'};
  }
`

const CustomButton = `
  width: 100%;
  margin-top: 20px;
  padding: 10px;

  > div {
    justify-content: center;
  }
`
const ContainerNote = styled.div`
  text-align: center;

  > p{
    font-size: 12px;
    color: white;
  }
`

const ContainerOption = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin 15px auto;

  > div:nth-child(1), 
  > div:nth-child(2) {
    display: flex;
    flex-direction: row;
    gap: 10px;
    color: white;
    font-size: 12px;
  }
`
const customSelect = `
  width: auto;

  select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
  }

  select::-ms-expand {
    display: none;
  }
`

const listFilter = [
  {
    icon: <Dollar />,
    text: 'Más barato'
  },
  {
    icon: <Flash />,
    text: 'Más Rápido'
  },
  {
    icon: <Sun />,
    text: 'Más Temprano'
  },
  {
    icon: <Moon />,
    text: 'Más Tarde'
  },
]

interface IOwnProps {
  onClick: (step: number) => void
}

const DestinyComponent: React.FunctionComponent<IOwnProps> = ({ onClick }) => {
  const [statusType, setStatusType] = React.useState<string>('ida_vuelta')
  
  return (
    <ContainerDestinations>
        <ContainerSearch hidden={true}>
          <ContainerData>
            <div><Bus2 /> <h3>Cambiar Destino</h3></div>
            <ContainerOption>
              <div>
                <CustomRadio active={statusType === 'ida_vuelta'} onClick={() => setStatusType('ida_vuelta')}><div /></CustomRadio>
                <span>Ida y vuelta</span>
              </div>
              <div>
                <CustomRadio active={statusType === 'ida'} onClick={() => setStatusType('ida')}><div /></CustomRadio>
                <span>Solo ida</span>
              </div>
            </ContainerOption>
            <ContainerForm>
              <div>
                <SelectTC
                  textHolder='Origen'
                  background='white'
                  icon={<Location />}
                  className={customSelect}
                  listOptions={['Trujillo', 'Lima','Trujillo']}
                />
              </div>
              <div>
                <SelectTC
                  textHolder='Destino'
                  background='white'
                  icon={<Location />}
                  className={customSelect}
                  listOptions={['Trujillo', 'Lima','Trujillo']}
                />
              </div>
              <div>
                <CalendarTC
                  icon={<Calendar />}
                  textHolder='Ida'
                  background='white'
                />
              </div>
              <div>
                <CalendarTC
                  icon={<Calendar />}
                  textHolder='Regreso'
                  background='white'
                />
              </div>
              <div>
                <ButtonTC text='Modificar Búsqueda' buttonStyle='secondary' className={CustomButton}/>
              </div>
              <ContainerNote><p>Nota: Si tiene algún inconveniente con su compra, comuníquese con nosotros al correo postventa@.pe en el horario de 6:30am a 10:30am de Lunes a Domingo.</p></ContainerNote>
            </ContainerForm>
            <p></p>
          </ContainerData>
        </ContainerSearch>
        <ContainerTicket>
            <div>
              <h3>
                Lima
                <ArrowRight />
                Chiclayo
              </h3>
            </div>
            <DestinyBar />
            <ContainerFilter>
              <div>Resultados: 5</div>
              <ContainerFilters>
                <div>Ordenar por:</div>
                {listFilter.map(filter => (
                  <FilterItem icon={filter.icon} text={filter.text}/>
                ))}
              </ContainerFilters>
            </ContainerFilter>
            {listTicketItem.map(ticket => (
                <TicketItem
                    type={ticket.type}
                    inclination={ticket.inclination}
                    seatingNumber={ticket.seatingNumber}
                    price={ticket.price}
                    initTime={ticket.initTime}
                    arrivalTime={ticket.arrivalTime}
                    fromCity={ticket.fromCity}
                    toCity={ticket.toCity}
                    time={ticket.time}
                    listOptions={ticket.listOptions}
                    onClick={() => onClick(2)}
                />
            ))}
        </ContainerTicket>
        <ContainerSearch hidden={false}>
          <ContainerData>
            <div><Bus2 /> <h3>Cambiar Destino</h3></div>
            <ContainerOption>
              <div>
                <CustomRadio active={statusType === 'ida_vuelta'} onClick={() => setStatusType('ida_vuelta')}><div /></CustomRadio>
                <span>Ida y vuelta</span>
              </div>
              <div>
                <CustomRadio active={statusType === 'ida'} onClick={() => setStatusType('ida')}><div /></CustomRadio>
                <span>Solo ida</span>
              </div>
            </ContainerOption>
            <ContainerForm>
              <div>
                <SelectTC
                  textHolder='Origen'
                  background='white'
                  icon={<Location />}
                  className={customSelect}
                  listOptions={['Trujillo', 'Lima','Trujillo']}
                />
              </div>
              <div>
                <SelectTC
                  textHolder='Destino'
                  background='white'
                  icon={<Location />}
                  className={customSelect}
                  listOptions={['Trujillo', 'Lima','Trujillo']}
                />
              </div>
              <div>
                <CalendarTC
                  icon={<Calendar />}
                  textHolder='Ida'
                  background='white'
                />
              </div>
              <div>
                <CalendarTC
                  icon={<Calendar />}
                  textHolder='Regreso'
                  background='white'
                />
              </div>
              <div>
                <ButtonTC text='Modificar Búsqueda' buttonStyle='secondary' className={CustomButton}/>
              </div>
              <ContainerNote><p>Nota: Si tiene algún inconveniente con su compra, comuníquese con nosotros al correo postventa@.pe en el horario de 6:30am a 10:30am de Lunes a Domingo.</p></ContainerNote>
            </ContainerForm>
            <p></p>
          </ContainerData>
        </ContainerSearch>
    </ContainerDestinations>
  )
}

export default DestinyComponent